import { Auth } from 'aws-amplify'
import actionCreatorFactory from 'typescript-fsa'
import { ApplicationState } from '../../../reducers'
import { itemLoading, itemLoaded } from '../loading/actions'
import {
    loadEvents as getEvents,
    loadEventExtraData as getEventExtraData,
} from '../../../services/Api'
import { eventsLoaded, eventDetailsLoaded } from '../../../data/actions'
import Event from '../../../models/event'
import { currentEventFromEventsSelector, isEventRunning } from '../../../data/selectors'

function loadEvents(isByTimer: boolean = false) {
    return async (dispatch: any, getState: () => ApplicationState) => {
        if (!isByTimer) {
            dispatch(itemLoading())
        }
        try {
            let events = await getEvents()
            const user = await Auth.currentUserInfo()

            // Change the start times to early bird time if the user is logged in
            if (user) {
                events = events.map((event) => {
                    if (event.earlyBirdStart) {
                        event.start = event.earlyBirdStart
                    }
                    return event
                })
            }

            dispatch(eventsLoaded(events))
            const event = currentEventFromEventsSelector(events)
            const running = await isEventRunning(event)
            if (event !== undefined && running) {
                dispatch(eventStarted(event))
            } else {
                dispatch(noEventRunning())
            }
        } catch (e) {
            if (!isByTimer) {
                dispatch(itemLoaded())
            }
            return
        }
        if (!isByTimer) {
            dispatch(itemLoaded())
        }
    }
}

function eventStarted(currentEvent: Event) {
    return async (dispatch: any, getState: () => ApplicationState) => {
        dispatch(eventRunning())
        dispatch(itemLoading())
        try {
            // load event categories & collections
            const updatedCurrentEvent = await getEventExtraData(currentEvent.slug).then(
                async (eventExtra) => {
                    if (eventExtra.categories !== undefined) {
                        currentEvent.categories = eventExtra.categories.map((eventCategory) => {
                            return {
                                slug: eventCategory.slug,
                                name: eventCategory.name,
                                sortOrder: eventCategory.sortOrder,
                                featuredBrands: eventCategory.featuredBrands,
                                featuredDealSlug: eventCategory.featuredDealSlug,
                                brands: eventCategory.brands,
                                subCategories: eventCategory.subCategories === undefined ?
                                    [] : eventCategory.subCategories.map(
                                        (subCategory) => {
                                            return {
                                                slug: subCategory.slug,
                                                name: subCategory.name,
                                                sortOrder: subCategory.sortOrder,
                                            }
                                        }),
                            }
                        })
                    }

                    currentEvent.partnerOne = eventExtra.partnerOne
                    currentEvent.partnerTwo = eventExtra.partnerTwo
                    currentEvent.homepageFeaturedBrands = eventExtra.homepageFeaturedBrands
                    currentEvent.homepageTopRetailers = eventExtra.homepageTopRetailers
                    currentEvent.menu = eventExtra.menu
                    currentEvent.searchFeaturedDeal = eventExtra.searchFeaturedDeal
                    currentEvent.searchFeaturedBrands = eventExtra.searchFeaturedBrands
                    currentEvent.membershipBenefits = eventExtra.membershipBenefits
                    currentEvent.collections = eventExtra.collections
                    return currentEvent
                }
            )

            const updatedEvents = getState().data.events.map((event) => {
                if (updatedCurrentEvent.slug === event.slug) {
                    return updatedCurrentEvent
                }
                return event
            })
            // dispatch data is loaded
            dispatch(eventDetailsLoaded(updatedEvents))
        } catch (e) {
            dispatch(itemLoaded())
        }
        dispatch(itemLoaded())
    }
}

const actionCreator = actionCreatorFactory('STATUS')
const eventRunning = actionCreator('EVENT_RUNNING')
const noEventRunning = actionCreator('NO_EVENT_RUNNING')

export {
    loadEvents,
    eventStarted,
    eventRunning,
    noEventRunning,
}
